/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Raffles, RafflesInterface } from "../../contracts/Raffles";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "have",
        type: "address",
      },
      {
        internalType: "address",
        name: "want",
        type: "address",
      },
    ],
    name: "OnlyCoordinatorCanFulfill",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "previousAdmin",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "newAdmin",
        type: "address",
      },
    ],
    name: "AdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "beacon",
        type: "address",
      },
    ],
    name: "BeaconUpgraded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "roundId",
        type: "uint256",
      },
    ],
    name: "NewRoundCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "roundId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "requestId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "randomWord",
        type: "uint256",
      },
    ],
    name: "OracleRequestFulfilled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "roundId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "requestId",
        type: "uint256",
      },
    ],
    name: "OracleRequestSent",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "roundId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tickets",
        type: "uint256",
      },
    ],
    name: "RoundEntered",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "roundId",
        type: "uint256",
      },
    ],
    name: "RoundFinished",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "member",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "TicketsCollected",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "implementation",
        type: "address",
      },
    ],
    name: "Upgraded",
    type: "event",
  },
  {
    inputs: [],
    name: "CLAIM_PERIOD",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DAYS_STREAK_FOR_TICKET",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "OPERATOR_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "TICKET_ID",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "TICKET_PRICE",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "UPGRADER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "buyTickets",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "claimDay",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "startTime",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "duration",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "initialPrize",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "tokensForOneTicket",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "maxTicketsFromOneMember",
        type: "uint256",
      },
      {
        internalType: "uint256[]",
        name: "winnersForLevel",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "prizeForLevel",
        type: "uint256[]",
      },
    ],
    name: "createRaffleRound",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "roundId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "tickets",
        type: "uint256",
      },
    ],
    name: "entryRaffle",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "extraTicketsPowerD",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "extract",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "roundId",
        type: "uint256",
      },
    ],
    name: "finishRaffleRound",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "getActiveRounds",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "startTime",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "duration",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "isClosed",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "isOracleFulfilled",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "isFinished",
            type: "bool",
          },
          {
            internalType: "uint256",
            name: "initialPrize",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "totalPrize",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "maxTicketsFromOneMember",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "tokensForOneTicket",
            type: "uint256",
          },
          {
            internalType: "uint256[]",
            name: "winnersForLevel",
            type: "uint256[]",
          },
          {
            internalType: "uint256[]",
            name: "prizeForLevel",
            type: "uint256[]",
          },
          {
            internalType: "uint256",
            name: "totalTickets",
            type: "uint256",
          },
          {
            internalType: "address[]",
            name: "members",
            type: "address[]",
          },
          {
            internalType: "uint256",
            name: "randomWord",
            type: "uint256",
          },
          {
            internalType: "address[][]",
            name: "winners",
            type: "address[][]",
          },
        ],
        internalType: "struct IRaffles.Round[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "getClaimStreak",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "getLastClaimTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "length",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "offset",
        type: "uint256",
      },
    ],
    name: "getLastFinishedRounds",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "startTime",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "duration",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "isClosed",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "isOracleFulfilled",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "isFinished",
            type: "bool",
          },
          {
            internalType: "uint256",
            name: "initialPrize",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "totalPrize",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "maxTicketsFromOneMember",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "tokensForOneTicket",
            type: "uint256",
          },
          {
            internalType: "uint256[]",
            name: "winnersForLevel",
            type: "uint256[]",
          },
          {
            internalType: "uint256[]",
            name: "prizeForLevel",
            type: "uint256[]",
          },
          {
            internalType: "uint256",
            name: "totalTickets",
            type: "uint256",
          },
          {
            internalType: "address[]",
            name: "members",
            type: "address[]",
          },
          {
            internalType: "uint256",
            name: "randomWord",
            type: "uint256",
          },
          {
            internalType: "address[][]",
            name: "winners",
            type: "address[][]",
          },
        ],
        internalType: "struct IRaffles.Round[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "getRound",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "startTime",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "duration",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "isClosed",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "isOracleFulfilled",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "isFinished",
            type: "bool",
          },
          {
            internalType: "uint256",
            name: "initialPrize",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "totalPrize",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "maxTicketsFromOneMember",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "tokensForOneTicket",
            type: "uint256",
          },
          {
            internalType: "uint256[]",
            name: "winnersForLevel",
            type: "uint256[]",
          },
          {
            internalType: "uint256[]",
            name: "prizeForLevel",
            type: "uint256[]",
          },
          {
            internalType: "uint256",
            name: "totalTickets",
            type: "uint256",
          },
          {
            internalType: "address[]",
            name: "members",
            type: "address[]",
          },
          {
            internalType: "uint256",
            name: "randomWord",
            type: "uint256",
          },
          {
            internalType: "address[][]",
            name: "winners",
            type: "address[][]",
          },
        ],
        internalType: "struct IRaffles.Round",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getRounds",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "startTime",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "duration",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "isClosed",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "isOracleFulfilled",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "isFinished",
            type: "bool",
          },
          {
            internalType: "uint256",
            name: "initialPrize",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "totalPrize",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "maxTicketsFromOneMember",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "tokensForOneTicket",
            type: "uint256",
          },
          {
            internalType: "uint256[]",
            name: "winnersForLevel",
            type: "uint256[]",
          },
          {
            internalType: "uint256[]",
            name: "prizeForLevel",
            type: "uint256[]",
          },
          {
            internalType: "uint256",
            name: "totalTickets",
            type: "uint256",
          },
          {
            internalType: "address[]",
            name: "members",
            type: "address[]",
          },
          {
            internalType: "uint256",
            name: "randomWord",
            type: "uint256",
          },
          {
            internalType: "address[][]",
            name: "winners",
            type: "address[][]",
          },
        ],
        internalType: "struct IRaffles.Round[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getTotalRounds",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "roundId",
        type: "uint256",
      },
    ],
    name: "getUserRoundEntry",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "getWinnerPrize",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "roundId",
        type: "uint256",
      },
    ],
    name: "getWinnersFromOracleRandom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "ticketPrice",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "ticketId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "daysStreakForTicket",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "contractManagerAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "coordinator",
        type: "address",
      },
      {
        internalType: "uint64",
        name: "subscriptionId",
        type: "uint64",
      },
      {
        internalType: "bytes32",
        name: "keyHash",
        type: "bytes32",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "isClaimAvailable",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "isMintAvailable",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "mintMyTicket",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "oracleRequests",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "proxiableUUID",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "requestId",
        type: "uint256",
      },
      {
        internalType: "uint256[]",
        name: "randomWords",
        type: "uint256[]",
      },
    ],
    name: "rawFulfillRandomWords",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "rounds",
    outputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "startTime",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "duration",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "isClosed",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "isOracleFulfilled",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "isFinished",
        type: "bool",
      },
      {
        internalType: "uint256",
        name: "initialPrize",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "totalPrize",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "maxTicketsFromOneMember",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "tokensForOneTicket",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "totalTickets",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "randomWord",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalBurnedTickets",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "gasLimit",
        type: "uint32",
      },
    ],
    name: "updateCallbackGasLimit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "sec",
        type: "uint256",
      },
    ],
    name: "updateClaimPeriod",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "coordinator",
        type: "address",
      },
    ],
    name: "updateCoordinator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "daysNum",
        type: "uint256",
      },
    ],
    name: "updateDaysStreakForTicket",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "updateExtraTicketsPowerD",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "kayHash",
        type: "bytes32",
      },
    ],
    name: "updateKeyHash",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "confirmations",
        type: "uint16",
      },
    ],
    name: "updateRequestConfirmations",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint64",
        name: "id",
        type: "uint64",
      },
    ],
    name: "updateSubscriptionId",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "updateTicketId",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
    ],
    name: "updateTicketPrice",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "isEnabled",
        type: "bool",
      },
    ],
    name: "updateWinnerCalculationInRequest",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address",
      },
    ],
    name: "upgradeTo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "upgradeToAndCall",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type RafflesConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: RafflesConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Raffles__factory extends ContractFactory {
  constructor(...args: RafflesConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(overrides?: Overrides & { from?: string }): Promise<Raffles> {
    return super.deploy(overrides || {}) as Promise<Raffles>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: string }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): Raffles {
    return super.attach(address) as Raffles;
  }
  override connect(signer: Signer): Raffles__factory {
    return super.connect(signer) as Raffles__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): RafflesInterface {
    return new utils.Interface(_abi) as RafflesInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Raffles {
    return new Contract(address, _abi, signerOrProvider) as Raffles;
  }
}
